// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3v_DH","footer":"ChangeClinic_footer__pluNo"};